<template>
  <div
    class="relative row-span-1 flex cursor-pointer flex-col items-center rounded-xl p-3 shadow-main transition-all hover:-translate-y-2 hover:shadow-elevated "
    :class="{
      'col-span-2': dish.size == 2,
      'col-span-1': dish.size != 2,
      'lg:p-7': props.size != 'row',
      'lg:p-4': props.size == 'row',
  }"
    @click="showDialog = true"
  >
    <div
      v-if="categoryTags"
      class="absolute right-4 top-4 z-20 flex flex-col items-end gap-2"
    >
      <div
        v-for="tag in shownTags"
        :key="tag.id"
        class="flex items-center gap-2 rounded-full bg-white px-3 py-1 text-xs shadow-main"
      >
        <img
          v-if="tag.img"
          :src="tag.img"
          class="h-4"
          alt=""
        />
        {{ tag.name }}
      </div>
    </div>

      <template v-if="props.size == 'row'">
          <div class="flex w-full gap-5">
              <div class="h-28 w-auto overflow-hidden"
              >
                  <MyImage
                      :src="dish.thumbnail"
                      :alt="dish.name"
                  />
              </div>
              <div class="flex flex-col justify-between w-full">
                  <div>
                      <NuxtLink
                          :to="'/'+dish.link"
                          class="mb-auto mt-4 text-center"
                          @click.stop=""
                      >
                          {{ dish.name }}
                      </NuxtLink>
                      <template v-if="props.showWeight">
                          <div>
                              <span class="h-4 w-px bg-black"></span>
                              <span class="font-base lg:text-md text-xs !leading-none"> {{ dish.weight }} гр </span>
                          </div>
                      </template>
                  </div>
                  <div class="flex justify-between items-center gap-4">
                      <span class="text-sm font-medium !leading-none lg:text-lg shrink-0"><span class="line-through text-[#91908F] font-normal pr-1" v-if="dish.old_price">{{ dish.old_price }}</span> {{ dish.price }} &#8381; </span>
                      <ClientOnly>
                          <DishAdder
                              :dish-id="dish.id"
                              :dish-name="dish.name"
                              :can-deliver="dish.can_deliver"
                              :available="dish.available"
                              class="w-full max-w-[200px] h-9 lg:h-10"
                          />
                      </ClientOnly>
                  </div>
              </div>
          </div>

      </template>
      <template v-else>
          <div class="h-28 w-auto overflow-hidden sm:h-36 md:h-40 lg:h-32 lg:max-lg:mt-0 xl:h-48"
               :class="props.size == 'small' ? 'xl:h-36' : 'xl:h-48 mt-4'"
          >
              <MyImage
                  :src="dish.thumbnail"
                  :alt="dish.name"
              />
          </div>

          <div class="text-sm font-medium lg:text-xl self-start my-2 lg:my-4"><span class="line-through text-[#91908F] font-normal pr-1" v-if="dish.old_price">{{ dish.old_price }}</span> {{ dish.price }} &#8381; </div>

          <div class="self-start mb-auto">
              <NuxtLink
                  :to="dish.link"
                  class="block text-xs/3 lg:text-base/5"
                  @click.stop=""
              >
                  {{ dish.name }}
              </NuxtLink>
              <div class="lg:text-base text-xs text-[#91908F] mt-1" v-if="props.showWeight"> {{ dish.weight }} гр </div>
          </div>

    <div
      class="flex justify-between self-stretch mt-4"
      :class="{
        'flex-row items-center gap-8': dish.size === 2,
        'flex-col items-stretch gap-4': dish.size !== 2,
    }"
    >
      <div
        class="h-9 w-full lg:h-10"
        :class="dish.size === 2 ? 'max-w-[16rem]' : ''"
      >
        <ClientOnly>
          <DishAdder
            :dish-id="dish.id"
            :dish-name="dish.name"
            :can-deliver="dish.can_deliver"
            :available="dish.available"
            class="h-full w-full"
          />
        </ClientOnly>
      </div>
    </div>
      </template>
    <DishCardDialog
      :dish="dish"
      :show="showDialog"
      @close="showDialog = false"
    />
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import type { Dish, Tag } from '~/interfaces/dishes'

const props = withDefaults(defineProps<{ dish: Dish; categoryTags?: Tag[]; shouldIncludeTag?: number; showWeight?: boolean; size?: string }>(), {
    showWeight: true,
    size: 'full',
})
const { dish } = toRefs(props)

const showDialog = ref(false)

const tags = computed(() => props.categoryTags?.filter((tag) => dish.value.tags?.includes(tag.id)))

const shownTags = computed(() => {
  if (tags.value && props.shouldIncludeTag) {
    const tagsToBeShown: Tag[] = []

    const tag = tags.value.find((tag) => tag.id === props.shouldIncludeTag)
    if (tag) {
      tagsToBeShown.push(tag)
    }
    const otherTags = tags.value.filter((tag) => tag.id !== props.shouldIncludeTag)

    const needAdd = otherTags.slice(0, Math.min(2 - tagsToBeShown.length, otherTags.length))

    tagsToBeShown.push(...needAdd)

    return tagsToBeShown
  }
  return tags.value?.splice(0, 2)
})
</script>
